export class Site {
  public libelle: string = "";
  public caisses: string[] = new Array();
  public vendeurs: string[] = new Array();
  public restaurantId: number = -1;
  public groupe: string[] = new Array();
  public codeAlpha: string = "";
  public extras?: any;

  constructor(nom: string) {
    this.libelle = nom;
  }
}
export interface SiteFromServer {
  "site+caisses": any;
  "site+restaurantid": any;
  "site+vendeurs": any;
  "site+codeimplant": any;
}
